/**
 * Dias da semana
 */
export enum DaysOfWeek {
  SUNDAY = 'SUNDAY',
  MONDAY = 'MONDAY',
  TUESDAY = 'TUESDAY',
  WEDNESDAY = 'WEDNESDAY',
  THURSDAY = 'THURSDAY',
  FRIDAY = 'FRIDAY',
  SATURDAY = 'SATURDAY',
}

export class ScheduleWeek {
  uuid!: string;
  days_of_week!: DaysOfWeek;
  description!: string;
  created_at!: string;
  updated_at!: string;
  business_unit_uuid?: string;
}

export const textByDayOfTheWeek: Record<DaysOfWeek, string> = {
  [DaysOfWeek.SUNDAY]: 'Domingo',
  [DaysOfWeek.MONDAY]: 'Segunda-Feira',
  [DaysOfWeek.TUESDAY]: 'Terça-Feira',
  [DaysOfWeek.WEDNESDAY]: 'Quarta-Feira',
  [DaysOfWeek.THURSDAY]: 'Quinta-Feira',
  [DaysOfWeek.FRIDAY]: 'Sexta-Feira',
  [DaysOfWeek.SATURDAY]: 'Sábado',
};
